import { Tooltip } from 'react-tippy';

// Used to override typing issue of old package used for tooltips (react-tippy)
export const OldTooltip = ({ children, ...props }) => {
  // @ts-ignore
  return <Tooltip {...props}>{children}</Tooltip>;
};
